var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lotes-popup" },
    [
      _vm.lotesList.show
        ? _c("LotesList2", {
            ref: "loteslist2",
            attrs: {
              user: _vm.user,
              idis: _vm.lotesList.idis,
              id_lote: _vm.newLote.id,
              tipo_lote: _vm.newLote.tipo_lote_selected.id,
              permisos: _vm.permisos,
              show_only: _vm.showOnly
            },
            on: {
              hidden: function($event) {
                _vm.lotesList.show = false
              },
              deleteFromLote: _vm.deleteFromLote,
              deleteFromParametrizadoLote: _vm.deleteFromParametrizadoLote
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.lotesListSolapados.show
        ? _c("LotesListSolapados", {
            ref: "loteslistsolapados",
            attrs: {
              user: _vm.user,
              idis: _vm.lotesListSolapados.idis,
              id_lote: _vm.newLote.id,
              tipo_lote: _vm.newLote.tipo_lote_selected.id,
              permisos: _vm.permisos,
              show_only: _vm.showOnly
            },
            on: {
              hidden: function($event) {
                _vm.lotesListSolapados.show = false
              },
              deleteFromLote: _vm.deleteFromLote,
              deleteFromParametrizadoLote: _vm.deleteFromParametrizadoLote
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "addEstablecimientoModal",
          staticClass: "fixedModal",
          attrs: {
            size: "md",
            id: "addEstablecimientoModal",
            title: "Añadir establecimientos",
            centered: ""
          },
          on: { ok: _vm.addEstablecimientoModalOkSync }
        },
        [
          _c("template", { slot: "modal-ok" }, [_vm._v("Aceptar")]),
          _vm._v(" "),
          _c("template", { slot: "modal-cancel" }, [_vm._v("Cancelar")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: 12 } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "exampleInputGroup1",
                        label: "IDIs Establecimientos",
                        "label-for": "exampleInput1",
                        description: "Separados por saltos de línea"
                      }
                    },
                    [
                      _c("b-form-textarea", {
                        staticClass: "mb-3",
                        attrs: { width: "100%", rows: 8 },
                        model: {
                          value: _vm.addEstablecimientoModal.textarea,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.addEstablecimientoModal,
                              "textarea",
                              $$v
                            )
                          },
                          expression: "addEstablecimientoModal.textarea"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.addEstablecimientoModal.error
                    ? _c("span", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.addEstablecimientoModal.error))
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "showEstablecimientoModal",
          staticClass: "fixedModal",
          attrs: {
            "ok-only": "",
            size: "md",
            id: "showEstablecimientoModal",
            title: "Listado de establecimientos",
            centered: ""
          }
        },
        [
          _c("template", { slot: "modal-ok" }, [_vm._v("Cerrar")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: 12 } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "exampleInputGroup1",
                        label: "Listado de IDIs",
                        "label-for": "exampleInput1"
                      }
                    },
                    [
                      _c("b-form-textarea", {
                        staticClass: "mb-3",
                        attrs: {
                          width: "100%",
                          rows: 8,
                          value: _vm.newLote.filtro_manual.join("\r\n")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "removeEstablecimientoModal",
          staticClass: "fixedModal",
          attrs: {
            size: "md",
            id: "removeEstablecimientoModal",
            title: "Quitar establecimientos",
            centered: ""
          },
          on: { ok: _vm.removeEstablecimientoModalOk }
        },
        [
          _c("template", { slot: "modal-ok" }, [_vm._v("Aceptar")]),
          _vm._v(" "),
          _c("template", { slot: "modal-cancel" }, [_vm._v("Cancelar")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: 12 } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "exampleInputGroup1",
                        label: "IDIs Establecimientos",
                        "label-for": "exampleInput1",
                        description: "Separados por saltos de línea"
                      }
                    },
                    [
                      _c("b-form-textarea", {
                        staticClass: "mb-3",
                        attrs: { width: "100%", rows: 8 },
                        model: {
                          value: _vm.removeEstablecimientoModal.textarea,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.removeEstablecimientoModal,
                              "textarea",
                              $$v
                            )
                          },
                          expression: "removeEstablecimientoModal.textarea"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.removeEstablecimientoModal.error
                    ? _c("span", { staticClass: "error" }, [
                        _vm._v(_vm._s(_vm.removeEstablecimientoModal.error))
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      !_vm.hideModalflag
        ? _c(
            "div",
            { staticClass: "popstyle2" },
            [
              _c(
                "b-modal",
                {
                  ref: "modalLotes",
                  staticClass: "fixedModal",
                  attrs: {
                    size: "lg",
                    id: "modal1",
                    title: _vm.modalTitle,
                    centered: "",
                    "hide-footer": true
                  },
                  on: { hidden: _vm.onHidden }
                },
                [
                  _vm.loading_table
                    ? _c("div", [_c("Loader", { attrs: { delay: 0 } })], 1)
                    : _c(
                        "div",
                        { staticClass: "scroll" },
                        [
                          !_vm.loteForm
                            ? [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            staticStyle: {
                                              "margin-left": "1rem"
                                            },
                                            attrs: {
                                              disabled: _vm.limitedPermision()
                                            },
                                            on: { input: _vm.updateTable },
                                            model: {
                                              value: _vm.toMe,
                                              callback: function($$v) {
                                                _vm.toMe = $$v
                                              },
                                              expression: "toMe"
                                            }
                                          },
                                          [_vm._v("Ver lotes asignados a mí")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.limitedPermision()
                                      ? _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                on: { input: _vm.updateTable },
                                                model: {
                                                  value: _vm.forMe,
                                                  callback: function($$v) {
                                                    _vm.forMe = $$v
                                                  },
                                                  expression: "forMe"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "Ver lotes asignados por mí"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.hasPermision(
                                  { rol: "GESTION COMERCIAL" },
                                  "E"
                                ) && !_vm.limitedPermision()
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "mt-3",
                                        on: { click: _vm.initAddLote }
                                      },
                                      [_vm._v("Añadir lote")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.loading_table
                                  ? _c("Table", {
                                      ref: "table",
                                      staticClass:
                                        "hideFilter mt-2 lotes-table",
                                      attrs: {
                                        url: "lotes/",
                                        options: _vm.options,
                                        columns: _vm.columns
                                      },
                                      on: { edit: _vm.editLote }
                                    })
                                  : _vm._e()
                              ]
                            : [
                                _c(
                                  "b-card",
                                  {
                                    staticClass: "text-center",
                                    staticStyle: { "border-color": "#7b7b7b" }
                                  },
                                  [
                                    _c("h2", [_vm._v("Datos lote")]),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { lg: "9" } },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _vm.newLote.id
                                                  ? _c(
                                                      "b-col",
                                                      { attrs: { lg: "2" } },
                                                      [
                                                        _c(
                                                          "b-form",
                                                          [
                                                            _c(
                                                              "b-form-group",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "1rem"
                                                                },
                                                                attrs: {
                                                                  label:
                                                                    "Código lote"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    attrs: {
                                                                      disabled:
                                                                        ""
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .newLote
                                                                          .id,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.newLote,
                                                                          "id",
                                                                          $$v
                                                                        )
                                                                      },
                                                                      expression:
                                                                        "newLote.id"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    attrs: {
                                                      lg: _vm.newLote.id ? 2 : 3
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b-form",
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              id: "tipolote",
                                                              label:
                                                                "Tipo Lote:",
                                                              "label-for":
                                                                "tipoloteinput"
                                                            }
                                                          },
                                                          [
                                                            _c("multiselect", {
                                                              staticClass:
                                                                "mb-3",
                                                              attrs: {
                                                                options:
                                                                  _vm.tipos_lotes,
                                                                id:
                                                                  "tipoloteinput",
                                                                allowEmpty: false,
                                                                placeholder: "",
                                                                label: "label",
                                                                disabled:
                                                                  _vm.showOnly,
                                                                "track-by":
                                                                  "id",
                                                                "preselect-first":
                                                                  ""
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.newLote
                                                                    .tipo_lote_selected,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.newLote,
                                                                    "tipo_lote_selected",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "newLote.tipo_lote_selected"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    attrs: {
                                                      lg: _vm.newLote.id ? 2 : 2
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b-form",
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              id: "metodolote",
                                                              label:
                                                                "Método Lote:",
                                                              "label-for":
                                                                "metodoloteinput"
                                                            }
                                                          },
                                                          [
                                                            _c("multiselect", {
                                                              staticClass:
                                                                "mb-3",
                                                              attrs: {
                                                                options:
                                                                  _vm.metodos_lotes,
                                                                id:
                                                                  "metodoloteinput",
                                                                allowEmpty: false,
                                                                placeholder: "",
                                                                disabled:
                                                                  _vm.showOnly,
                                                                label: "label",
                                                                "track-by":
                                                                  "id",
                                                                "preselect-first":
                                                                  ""
                                                              },
                                                              on: {
                                                                input:
                                                                  _vm.changedMetodoLote
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.newLote
                                                                    .metodo_lote_selected,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.newLote,
                                                                    "metodo_lote_selected",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "newLote.metodo_lote_selected"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  {
                                                    attrs: {
                                                      lg: _vm.newLote.id ? 2 : 3
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b-form",
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "1rem"
                                                            },
                                                            attrs: {
                                                              label: "Status"
                                                            }
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                disabled: ""
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.newLote
                                                                    .status,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.newLote,
                                                                    "status",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "newLote.status"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "2" } },
                                                  [
                                                    _c(
                                                      "b-form",
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "1rem"
                                                            },
                                                            attrs: {
                                                              label:
                                                                "Fecha inicio prevista"
                                                            }
                                                          },
                                                          [
                                                            _c("datetime", {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    "required",
                                                                  expression:
                                                                    "'required'"
                                                                }
                                                              ],
                                                              attrs: {
                                                                "input-class":
                                                                  "form-control",
                                                                phrases: {
                                                                  ok: "Ok",
                                                                  cancel:
                                                                    "Cancelar"
                                                                },
                                                                type: "date",
                                                                auto: true,
                                                                "value-zone":
                                                                  "local",
                                                                zone: "local",
                                                                name:
                                                                  "Fecha inicio prevista",
                                                                disabled:
                                                                  _vm.showOnly
                                                              },
                                                              on: {
                                                                input:
                                                                  _vm.changedFechaInicio
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.newLote
                                                                    .fecha_inicio_prevista,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.newLote,
                                                                    "fecha_inicio_prevista",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "newLote.fecha_inicio_prevista"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "error"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "Fecha inicio prevista"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "2" } },
                                                  [
                                                    _c(
                                                      "b-form",
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "1rem"
                                                            },
                                                            attrs: {
                                                              label:
                                                                "Fecha cierre prevista"
                                                            }
                                                          },
                                                          [
                                                            _c("datetime", {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    "required",
                                                                  expression:
                                                                    "'required'"
                                                                }
                                                              ],
                                                              attrs: {
                                                                id:
                                                                  "fecha_cierre_prevista",
                                                                "input-class":
                                                                  "form-control",
                                                                phrases: {
                                                                  ok: "Ok",
                                                                  cancel:
                                                                    "Cancelar"
                                                                },
                                                                type: "date",
                                                                auto: true,
                                                                "value-zone":
                                                                  "local",
                                                                zone: "local",
                                                                name:
                                                                  "Fecha cierre prevista",
                                                                disabled:
                                                                  _vm.showOnly
                                                              },
                                                              on: {
                                                                input:
                                                                  _vm.changedFechaCierre
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.newLote
                                                                    .fecha_cierre_prevista,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.newLote,
                                                                    "fecha_cierre_prevista",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "newLote.fecha_cierre_prevista"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "error"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "Fecha cierre prevista"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "2" } },
                                                  [
                                                    _c(
                                                      "b-form",
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "1rem"
                                                            },
                                                            attrs: {
                                                              label:
                                                                "Código asignador"
                                                            }
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                disabled: ""
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.newLote
                                                                    .usuario_asignador,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.newLote,
                                                                    "usuario_asignador",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "newLote.usuario_asignador"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "3" } },
                                                  [
                                                    _c(
                                                      "b-form",
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "1rem"
                                                            },
                                                            attrs: {
                                                              label:
                                                                "Nombre asignador"
                                                            }
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                disabled: ""
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.nombre_asignador,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.nombre_asignador = $$v
                                                                },
                                                                expression:
                                                                  "nombre_asignador"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "7" } },
                                                  [
                                                    _c(
                                                      "b-form",
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "1rem"
                                                            },
                                                            attrs: {
                                                              label:
                                                                "Descripción"
                                                            }
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    "required",
                                                                  expression:
                                                                    "'required'"
                                                                }
                                                              ],
                                                              attrs: {
                                                                name:
                                                                  "Descripción",
                                                                disabled:
                                                                  _vm.showOnly
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.newLote
                                                                    .descripcion,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.newLote,
                                                                    "descripcion",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "newLote.descripcion"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "error"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "Descripción"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { lg: "3" } },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "12" } },
                                                  [
                                                    _c(
                                                      "b-form",
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "1rem"
                                                            },
                                                            attrs: {
                                                              label:
                                                                "Observaciones"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "b-form-textarea",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "validate",
                                                                    rawName:
                                                                      "v-validate",
                                                                    value:
                                                                      "required",
                                                                    expression:
                                                                      "'required'"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  rows: "5",
                                                                  name:
                                                                    "Observaciones",
                                                                  disabled:
                                                                    _vm.showOnly
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.newLote
                                                                      .observaciones,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.newLote,
                                                                      "observaciones",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "newLote.observaciones"
                                                                }
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "error"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "Observaciones"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "b-card",
                                  {
                                    staticClass: "text-center",
                                    staticStyle: { "border-color": "#7b7b7b" }
                                  },
                                  [
                                    _c("h2", [_vm._v("Asignación")]),
                                    _vm._v(" "),
                                    _c(
                                      "b-form",
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "2" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "1rem"
                                                    },
                                                    attrs: {
                                                      label: "Código asignado"
                                                    }
                                                  },
                                                  [
                                                    _c("b-form-input", {
                                                      attrs: { disabled: "" },
                                                      model: {
                                                        value:
                                                          _vm.newLote
                                                            .usuario_asignado,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.newLote,
                                                            "usuario_asignado",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "newLote.usuario_asignado"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "error" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "Código asignado"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "3" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    staticClass: "autocomplete",
                                                    staticStyle: {
                                                      "font-size": "1rem"
                                                    },
                                                    attrs: {
                                                      label: "Nombre asignado"
                                                    }
                                                  },
                                                  [
                                                    _vm.showOnly
                                                      ? _c("b-form-input", {
                                                          directives: [
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: "required",
                                                              expression:
                                                                "'required'"
                                                            }
                                                          ],
                                                          attrs: {
                                                            autocomplete: "off",
                                                            name:
                                                              "Código asignado",
                                                            disabled: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.usuarioasignado,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.usuarioasignado = $$v
                                                            },
                                                            expression:
                                                              "usuarioasignado"
                                                          }
                                                        })
                                                      : _c("b-form-input", {
                                                          directives: [
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: "required",
                                                              expression:
                                                                "'required'"
                                                            }
                                                          ],
                                                          attrs: {
                                                            autocomplete: "off",
                                                            name:
                                                              "Código asignado"
                                                          },
                                                          on: {
                                                            input: _vm.loadUser
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.usuarioasignado,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.usuarioasignado = $$v
                                                            },
                                                            expression:
                                                              "usuarioasignado"
                                                          }
                                                        }),
                                                    _vm._v(" "),
                                                    _vm.show_names
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "autocomplete-items"
                                                          },
                                                          _vm._l(
                                                            _vm.names_suggestions,
                                                            function(
                                                              element,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: index,
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.setElement(
                                                                        element
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      element.first_name
                                                                    ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        element.last_name
                                                                      ) +
                                                                      " (" +
                                                                      _vm._s(
                                                                        element.username
                                                                      ) +
                                                                      ")"
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _vm.newLote.metodo_lote_selected.id === "Manual"
                                  ? _c(
                                      "b-card",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: {
                                          "border-color": "#7b7b7b"
                                        }
                                      },
                                      [
                                        _c("h2", [_vm._v("Lote Manual")]),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "auto" } },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.count_comerciales_in_geometry ===
                                                          "..." || _vm.showOnly
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.addEstablecimientos
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Añadir establecimientos"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "auto" } },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      disabled: _vm.showOnly
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.removeEstablecimientos
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Quitar establecimientos"
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "auto" } },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "outline-primary"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.showEstablecimientos
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  Establecimientos actuales\n                  "
                                                    ),
                                                    _c(
                                                      "b-badge",
                                                      {
                                                        attrs: {
                                                          variant: "primary"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.computedNumberManualEstablecimientos
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _vm.newLote.metodo_lote_selected.id ===
                                "Parametrizado"
                                  ? _c(
                                      "b-card",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: {
                                          "border-color": "#7b7b7b"
                                        }
                                      },
                                      [
                                        _c("h2", [_vm._v("Filtro atributos")]),
                                        _vm._v(" "),
                                        _c(
                                          "b-form",
                                          [
                                            _c(
                                              "b-form-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "4" } },
                                                  [
                                                    _vm.newLote
                                                      .tipo_lote_selected.id ===
                                                    "GC"
                                                      ? _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              id:
                                                                "categoriaestablecimiento",
                                                              label:
                                                                "Categoría Establecimiento:",
                                                              "label-for":
                                                                "categoriaestablecimientoinput"
                                                            }
                                                          },
                                                          [
                                                            _c("multiselect", {
                                                              staticClass:
                                                                "mb-3",
                                                              attrs: {
                                                                options:
                                                                  _vm
                                                                    .optsfiltros
                                                                    .id_categoria_gn_comercial,
                                                                id:
                                                                  "categoriaestablecimientoinput",
                                                                placeholder:
                                                                  "Seleccionar",
                                                                label:
                                                                  "categoria_gn_comercial",
                                                                multiple: "",
                                                                "track-by":
                                                                  "id",
                                                                disabled:
                                                                  _vm.showOnly ||
                                                                  _vm.newLote
                                                                    .metodo_lote_selected
                                                                    .id ===
                                                                    "Manual"
                                                              },
                                                              on: {
                                                                input:
                                                                  _vm.setOptionsTipoEstablecimiento
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.filtros
                                                                    .id_categoria_gn_comercial,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.filtros,
                                                                    "id_categoria_gn_comercial",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "filtros.id_categoria_gn_comercial"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              id:
                                                                "categoriaestablecimiento",
                                                              label:
                                                                "Categoria Establecimiento:",
                                                              "label-for":
                                                                "categoriaestablecimientoinput"
                                                            }
                                                          },
                                                          [
                                                            _c("multiselect", {
                                                              staticClass:
                                                                "mb-3",
                                                              attrs: {
                                                                options:
                                                                  _vm
                                                                    .parentoptsfiltroscaldera
                                                                    .id_categoria_gn_caldera,
                                                                id:
                                                                  "categoriaestablecimientoinput",
                                                                placeholder:
                                                                  "Seleccionar",
                                                                label:
                                                                  "categoria_gn_caldera",
                                                                multiple: "",
                                                                "track-by":
                                                                  "id",
                                                                disabled:
                                                                  _vm.showOnly ||
                                                                  _vm.newLote
                                                                    .metodo_lote_selected
                                                                    .id ===
                                                                    "Manual"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.filtros
                                                                    .id_categoria_gn_caldera,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.filtros,
                                                                    "id_categoria_gn_caldera",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "filtros.id_categoria_gn_caldera"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "4" } },
                                                  [
                                                    _vm.newLote
                                                      .tipo_lote_selected.id ===
                                                    "GC"
                                                      ? _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              id:
                                                                "tipoestablecimiento",
                                                              label:
                                                                "Tipo Establecimiento:",
                                                              "label-for":
                                                                "tipoestablecimientoinput"
                                                            }
                                                          },
                                                          [
                                                            _c("multiselect", {
                                                              staticClass:
                                                                "mb-3",
                                                              attrs: {
                                                                options:
                                                                  _vm
                                                                    .optsfiltros
                                                                    .id_tipo_establecimiento_gn_comercial,
                                                                id:
                                                                  "tipoestablecimientoinput",
                                                                placeholder:
                                                                  "Seleccionar",
                                                                label: "tipo",
                                                                name:
                                                                  "Tipo establecimiento",
                                                                multiple: "",
                                                                "track-by":
                                                                  "id",
                                                                disabled:
                                                                  _vm.showOnly ||
                                                                  _vm.newLote
                                                                    .metodo_lote_selected
                                                                    .id ===
                                                                    "Manual"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.filtros
                                                                    .id_tipo_establecimiento_gn_comercial,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.filtros,
                                                                    "id_tipo_establecimiento_gn_comercial",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "filtros.id_tipo_establecimiento_gn_comercial"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "error"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "Tipo establecimiento"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              id:
                                                                "tipoestablecimiento",
                                                              label:
                                                                "Tipo Establecimiento:",
                                                              "label-for":
                                                                "tipoestablecimientoinput"
                                                            }
                                                          },
                                                          [
                                                            _c("multiselect", {
                                                              staticClass:
                                                                "mb-3",
                                                              attrs: {
                                                                options:
                                                                  _vm
                                                                    .parentoptsfiltroscaldera
                                                                    .id_tipo_establecimiento_gn_caldera,
                                                                id:
                                                                  "tipoestablecimientoinput",
                                                                placeholder:
                                                                  "Seleccionar",
                                                                label: "tipo",
                                                                name:
                                                                  "Tipo establecimiento",
                                                                multiple: "",
                                                                "track-by":
                                                                  "id",
                                                                disabled:
                                                                  _vm.showOnly ||
                                                                  _vm.newLote
                                                                    .metodo_lote_selected
                                                                    .id ===
                                                                    "Manual"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.filtros
                                                                    .id_tipo_establecimiento_gn_caldera,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.filtros,
                                                                    "id_tipo_establecimiento_gn_caldera",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "filtros.id_tipo_establecimiento_gn_caldera"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "error"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "Tipo establecimiento"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "4" } },
                                                  [
                                                    _vm.newLote
                                                      .tipo_lote_selected.id ===
                                                    "GC"
                                                      ? _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              id:
                                                                "claseestablecimiento",
                                                              label:
                                                                "Clase de establecimiento NEDGIA:",
                                                              "label-for":
                                                                "claseestablecimientoinput"
                                                            }
                                                          },
                                                          [
                                                            _c("multiselect", {
                                                              staticClass:
                                                                "mb-3",
                                                              attrs: {
                                                                multiple: "",
                                                                options:
                                                                  _vm
                                                                    .optsfiltros
                                                                    .id_clase_establecimiento_gn_comercial,
                                                                id:
                                                                  "claseestablecimientoinput",
                                                                placeholder:
                                                                  "Seleccionar",
                                                                label: "tipo",
                                                                "track-by":
                                                                  "id",
                                                                disabled:
                                                                  _vm.showOnly ||
                                                                  _vm.newLote
                                                                    .metodo_lote_selected
                                                                    .id ===
                                                                    "Manual"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.filtros
                                                                    .id_clase_establecimiento_gn_comercial,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.filtros,
                                                                    "id_clase_establecimiento_gn_comercial",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "filtros.id_clase_establecimiento_gn_comercial"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              id:
                                                                "claseestablecimiento",
                                                              label:
                                                                "Clase de establecimiento NEDGIA:",
                                                              "label-for":
                                                                "claseestablecimientoinput"
                                                            }
                                                          },
                                                          [
                                                            _c("multiselect", {
                                                              staticClass:
                                                                "mb-3",
                                                              attrs: {
                                                                options:
                                                                  _vm
                                                                    .parentoptsfiltroscaldera
                                                                    .id_clase_establecimiento_gn_caldera,
                                                                id:
                                                                  "claseestablecimientoinput",
                                                                multiple: "",
                                                                placeholder:
                                                                  "Seleccionar",
                                                                label: "tipo",
                                                                "track-by":
                                                                  "id",
                                                                disabled:
                                                                  _vm.showOnly ||
                                                                  _vm.newLote
                                                                    .metodo_lote_selected
                                                                    .id ===
                                                                    "Manual"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.filtros
                                                                    .id_clase_establecimiento_gn_caldera,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.filtros,
                                                                    "id_clase_establecimiento_gn_caldera",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "filtros.id_clase_establecimiento_gn_caldera"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "4" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          id: "statusgestion",
                                                          label:
                                                            "Status gestión:",
                                                          "label-for":
                                                            "statusgestioninput"
                                                        }
                                                      },
                                                      [
                                                        _c("multiselect", {
                                                          staticClass: "mb-3",
                                                          attrs: {
                                                            options:
                                                              _vm.optsfiltros
                                                                .id_status_gestion,
                                                            multiple: "",
                                                            id:
                                                              "statusgestioninput",
                                                            placeholder:
                                                              "Seleccionar",
                                                            label: "status",
                                                            "track-by": "id",
                                                            disabled:
                                                              _vm.showOnly ||
                                                              _vm.newLote
                                                                .metodo_lote_selected
                                                                .id === "Manual"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.filtros
                                                                .id_status_gestion,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.filtros,
                                                                "id_status_gestion",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "filtros.id_status_gestion"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "4" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          id: "distancia",
                                                          label: "Distancia:",
                                                          "label-for":
                                                            "distanciainput"
                                                        }
                                                      },
                                                      [
                                                        _c("b-form-select", {
                                                          staticClass: "mb-3",
                                                          staticStyle: {
                                                            height: "43px"
                                                          },
                                                          attrs: {
                                                            name:
                                                              "Categoria GN",
                                                            options:
                                                              _vm.optsfiltros
                                                                .in_service_mains_distance,
                                                            "text-field":
                                                              "label",
                                                            "value-field": "id",
                                                            disabled:
                                                              _vm.showOnly ||
                                                              _vm.newLote
                                                                .metodo_lote_selected
                                                                .id === "Manual"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.filtros
                                                                .in_service_mains_distance,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.filtros,
                                                                "in_service_mains_distance",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "filtros.in_service_mains_distance"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              "Total " +
                                                _vm._s(_vm.textCount) +
                                                ": " +
                                                _vm._s(_vm.count_comerciales)
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        !_vm.showOnly
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.loadingtipos ||
                                                    _vm.newLote
                                                      .metodo_lote_selected
                                                      .id === "Manual"
                                                },
                                                on: {
                                                  click: _vm.getNumberOfComerces
                                                }
                                              },
                                              [
                                                _vm.loadingtipos
                                                  ? _c("span", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-spinner fa-spin fa-3x"
                                                      })
                                                    ])
                                                  : _c("span", [
                                                      _vm._v("Aplicar")
                                                    ])
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _vm.newLote.metodo_lote_selected.id ===
                                "Parametrizado"
                                  ? _c(
                                      "b-card",
                                      {
                                        staticClass: "text-center",
                                        staticStyle: {
                                          "border-color": "#7b7b7b"
                                        }
                                      },
                                      [
                                        _c("h2", [
                                          _vm._v("Filtro área geográfica")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-form",
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "2" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label:
                                                            "Número de geometrías"
                                                        }
                                                      },
                                                      [
                                                        _c("b-form-input", {
                                                          directives: [
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: "required",
                                                              expression:
                                                                "'required'"
                                                            }
                                                          ],
                                                          attrs: {
                                                            name:
                                                              "Numero de geometrias",
                                                            disabled: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.geometrias
                                                                .numero_geometrias,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.geometrias,
                                                                "numero_geometrias",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "geometrias.numero_geometrias"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "error"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "Numero de geometrias"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "2" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label:
                                                            "Número de " +
                                                            _vm.textCount
                                                        }
                                                      },
                                                      [
                                                        _c("b-form-input", {
                                                          directives: [
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: "required",
                                                              expression:
                                                                "'required'"
                                                            }
                                                          ],
                                                          attrs: {
                                                            name:
                                                              "Numero de comerciales",
                                                            disabled: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.count_comerciales_in_geometry,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.count_comerciales_in_geometry = $$v
                                                            },
                                                            expression:
                                                              "count_comerciales_in_geometry"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "error"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "Número de comerciales"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        !_vm.showOnly
                                          ? _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.newLote
                                                      .metodo_lote_selected
                                                      .id === "Manual"
                                                },
                                                on: { click: _vm.drawPolygon }
                                              },
                                              [_vm._v("Filtro área")]
                                            )
                                          : _c(
                                              "b-button",
                                              {
                                                on: {
                                                  click: _vm.drawPolygonView
                                                }
                                              },
                                              [_vm._v("Ver áreas")]
                                            )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-3" },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c(
                                          "b-button",
                                          { on: { click: _vm.cancelSaveLote } },
                                          [_vm._v("Cancelar")]
                                        ),
                                        _vm._v(" "),
                                        !_vm.showOnly
                                          ? _c(
                                              "b-button",
                                              {
                                                on: { click: _vm.validateLote }
                                              },
                                              [_vm._v("Guardar")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            on: { click: _vm.showModalResumen }
                                          },
                                          [_vm._v("Resumen")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          { on: { click: _vm.showModalList } },
                                          [_vm._v("Lista")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          { on: { click: _vm.exportarLote } },
                                          [_vm._v("Exportar")]
                                        ),
                                        _vm._v(" "),
                                        !_vm.showOnly
                                          ? _c(
                                              "b-button",
                                              {
                                                on: { click: _vm.checkSolapes }
                                              },
                                              [_vm._v("Solapes")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                        ],
                        2
                      )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  ref: "modalPreventDelete",
                  attrs: { id: "modalPreventDeleteid" },
                  on: {
                    ok: function($event) {
                      _vm.deleteLote()
                    },
                    hidden: _vm.hideModalPrevent
                  }
                },
                [_vm._v("¿Desea eliminar el lote?")]
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  ref: "modalResumeLote",
                  attrs: { id: "modalResumeLoteid", "ok-only": "" },
                  on: { hidden: _vm.hiddenModalResumen }
                },
                [
                  _c(
                    "b-list-group",
                    { staticClass: "scroll" },
                    [
                      _c(
                        "b-list-group-item",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [_vm._v("Categoría")]),
                              _vm._v(" "),
                              _c("b-col", [_vm._v("Visitas")]),
                              _vm._v(" "),
                              _c("b-col", [_vm._v("Sin Visitas")])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.cerrarlote_resumen, function(total, cat) {
                        return _c(
                          "b-list-group-item",
                          { key: "cerrarlote_" + cat },
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [_vm._v(_vm._s(cat))]),
                                _vm._v(" "),
                                _c("b-col", [_vm._v(_vm._s(total.visitas))]),
                                _vm._v(" "),
                                _c("b-col", [_vm._v(_vm._s(total.novisitas))])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  ref: "modalCerrarLote",
                  attrs: { id: "modalCerrarLoteid" },
                  on: {
                    ok: function($event) {
                      _vm.confirmModal = true
                    },
                    hidden: _vm.hideCerrarLote
                  }
                },
                [
                  _c(
                    "b-list-group",
                    { staticClass: "scroll" },
                    [
                      _c(
                        "b-list-group-item",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [_vm._v("Categoría")]),
                              _vm._v(" "),
                              _c("b-col", [_vm._v("Visitas")]),
                              _vm._v(" "),
                              _c("b-col", [_vm._v("Sin Visitas")])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.cerrarlote_resumen, function(total, cat) {
                        return _c(
                          "b-list-group-item",
                          { key: "cerrarlote_" + cat },
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [_vm._v(_vm._s(cat))]),
                                _vm._v(" "),
                                _c("b-col", [_vm._v(_vm._s(total.visitas))]),
                                _vm._v(" "),
                                _c("b-col", [_vm._v(_vm._s(total.novisitas))])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  ref: "modalPreventCerrarLote",
                  attrs: { id: "modalPreventCerrarLoteId" },
                  on: {
                    ok: _vm.cerrarLoteConfirm,
                    hidden: _vm.hideModalPreventCerrar
                  }
                },
                [_vm._v("¿Desea cerrar el lote?")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "8" } },
            [
              _c(
                "b-alert",
                { attrs: { show: _vm.gestionandoLote, variant: "primary" } },
                [
                  _vm._v(
                    "\n        Gestionando lote: " +
                      _vm._s(_vm.loteGestion) +
                      " (" +
                      _vm._s(_vm.loteGestionando.tipo_lote) +
                      ")\n        "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    { staticClass: "mt-2", on: { click: _vm.showList } },
                    [_vm._v("LISTA")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      staticClass: "mt-2",
                      staticStyle: { float: "right" },
                      on: { click: _vm.exitGestion }
                    },
                    [_vm._v("Finalizar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.listFlag
        ? _c("LotesList", {
            attrs: {
              user: _vm.user,
              id: _vm.loteGestion,
              tipo_lote: _vm.loteGestionando.tipo_lote,
              permisos: _vm.permisos
            },
            on: {
              hidden: function($event) {
                _vm.listFlag = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/LotesPopUp.vue?vue&type=template&id=1b15d772&
// module id = null
// module chunks = 